import React from 'react';
import useEnterAsTab from './hooks/useEnterAsTab';
import { BrowserRouter as Router } from 'react-router-dom';
import { RegistrationProvider } from './context/RegistrationContext';
import { ModalProvider } from './context/ModalContext';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Main component for registration flow
import RegistrationFlow from './components/registration/RegistrationFlow';

function App() {
  // Použitie hooku na presmerovanie klávesy Enter ako Tab
  useEnterAsTab();
  
  return (
    <RegistrationProvider>
      <ModalProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div className="flex flex-col min-h-screen bg-background">
            <Header />
            <main className="flex-grow">
              <RegistrationFlow />
            </main>
            <Footer />
          </div>
        </Router>
      </ModalProvider>
    </RegistrationProvider>
  );
}

export default App;
